import { render } from "./quiz-v1-question-response.vue?vue&type=template&id=74de429e&scoped=true"
import script from "./quiz-v1-question-response.vue?vue&type=script&lang=js"
export * from "./quiz-v1-question-response.vue?vue&type=script&lang=js"

import "./quiz-v1-question-response.vue?vue&type=style&index=0&id=74de429e&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74de429e"]])

export default __exports__